// Shared design tokens for the web app. Mirrors the mobile light theme so both
// surfaces read as one product.
export const C = {
  surface: "#0F2350", // dark navy (sidebar)
  onSurface: "#141A24",
  onSurfaceInverse: "#FFFFFF",
  surfaceSecondary: "#FFFFFF", // cards
  surfaceTertiary: "#EAF0F8",
  onSurfaceTertiary: "#3A4457",
  onSurfaceSecondary: "#2A3240",
  pageBg: "#EDF1F8",
  muted: "#68738A",
  mutedInverse: "#A9B6D9",

  brand: "#2563C9",
  brandPrimary: "#2563C9",
  onBrandPrimary: "#FFFFFF",
  brandSecondary: "#7BA7E6",
  brandTertiary: "#E1ECFF",
  onBrandTertiary: "#1B3A63",

  success: "#1F9D6B",
  warning: "#E08A00",
  error: "#E23D3D",
  info: "#2563C9",

  border: "#E1E7F0",
  borderStrong: "#BFC9DA",
  divider: "#EAEEF5",
};

export const STAGE_COLORS = {
  Assessment: "#7C3AED",
  Training: "#2563C9",
  "Check Ride": "#E08A00",
  "Targeted Training": "#0E9AA7",
  "Final Assessment": "#C026D3",
  "Approved for Test": "#1F9D6B",
  Disabled: "#E23D3D",
};

export const GRADE_COLORS = {
  Gold: "#C9A227",
  Silver: "#8A9099",
  Bronze: "#B0743B",
};

export const EVENT_TYPE_COLORS = {
  "Ride-out": "#2563C9",
  "Club Night": "#7C3AED",
  "Training Day": "#E08A00",
  Social: "#1F9D6B",
};
